import React from 'react';
import Logo from 'src/components/Logo/Logo';
import './ModernizedServiceRequestHeader.scss';

interface Props {
  callout?: React.ReactNode;
  details?: React.ReactNode;
}

const ModernizedServiceRequestHeader: React.FC<Props> = ({ callout, details }) => (
  <div className="offline-sr-header">
    <div className="offline-sr-header-top">
      <Logo />
      {callout && <div className="offline-sr-header-callout offline-sr-header-callout-desktop">{callout}</div>}
    </div>
    {callout && <div className="offline-sr-header-callout offline-sr-header-callout-mobile">{callout}</div>}
    {details && <div className="offline-sr-header-details">{details}</div>}
  </div>
);

export default ModernizedServiceRequestHeader;
